import { 
    Grid, 
    Paper, 
    FormControl, 
    Select, 
    MenuItem, 
    Button, 
    CircularProgress, 
    InputLabel 
} from '@mui/material';
import { KeyboardArrowDown, ErrorOutline } from '@mui/icons-material';

export default function TopControls({
    clients,
    selectedClient,
    onClientChange,
    lobs = [],
    selectedLob = '',
    onLobChange,
    loading,
    error,
    countryCode,
    onCountryChange,
    languageCode,
    onLanguageChange
}) {
    const lobsEmpty = lobs.length === 0;
    return (
        <Paper elevation={0} sx={{ border: '1px solid #ccc', borderRadius: 2, p: 1, mb: 3 }}>
            <Grid container spacing={1} alignItems="center">
                {/* LOB */}
                <Grid item>
                    <FormControl size="small" variant="outlined" sx={{ minWidth: 120 }} disabled={lobsEmpty}>
                        <InputLabel>LOB</InputLabel>
                        <Select
                            value={lobsEmpty ? '' : selectedLob}
                            onChange={(e) => onLobChange && onLobChange(e.target.value)}
                            label="LOB"
                            IconComponent={KeyboardArrowDown}
                            displayEmpty
                        >
                            {lobs.map((lob) => (
                                <MenuItem key={lob} value={lob}>{lob}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Client Name */}
                <Grid item>
                    <FormControl size="small" variant="outlined" sx={{minWidth: 150}}>
                        <InputLabel>Client Name</InputLabel>
                        <Select 
                            value={loading || error || clients.length === 0 ? '' : selectedClient} 
                            onChange={(e) => onClientChange(e.target.value)} 
                            label="Client Name"
                            IconComponent={KeyboardArrowDown}
                            disabled={loading || !!error}
                            startAdornment={loading && <CircularProgress size={20} sx={{mr: 1}} />}
                        >
                            {loading && <MenuItem value=""><em>Loading...</em></MenuItem>}
                            {error && <MenuItem value="" disabled><em><ErrorOutline fontSize="small"/> Error</em></MenuItem>}
                            {clients.map(c => (
                                <MenuItem key={c.ClientCode} value={c.ClientCode}>
                                    {c.ClientName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Country Code */}
                <Grid item>
                    <FormControl size="small" variant="outlined" sx={{minWidth: 120}}>
                        <InputLabel>Country</InputLabel>
                        <Select
                            value={countryCode}
                            onChange={(e) => onCountryChange(e.target.value)}
                            label="Country"
                            IconComponent={KeyboardArrowDown}
                        >
                            <MenuItem value="US">US</MenuItem>
                            <MenuItem value="CA">CA</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* Language */}
                <Grid item>
                    <FormControl size="small" variant="outlined" sx={{minWidth: 150}}>
                        <InputLabel>Language</InputLabel>
                        <Select 
                            value={languageCode} 
                            onChange={(e) => onLanguageChange(e.target.value)} 
                            label="Language" 
                            IconComponent={KeyboardArrowDown}
                        >
                            <MenuItem value="en">English</MenuItem>
                            <MenuItem value="fr">French</MenuItem>
                            <MenuItem value="es">Spanish</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {/* Button Row */}
            <Grid container spacing={1} sx={{ mt: 1 }}>
                <Grid item>
                    <Button variant="outlined" size="small" sx={{textTransform: 'none', color: 'black', borderColor: '#ccc'}}>
                        ALL
                    </Button>
                </Grid>
                <Grid item>
                    <Button 
                        variant="outlined" 
                        size="small" 
                        sx={{ textTransform: 'none', color: 'black', borderColor: '#ccc' }}
                    >
                        {languageCode === 'en' ? 'English' : languageCode === 'fr' ? 'French' : 'Spanish'}
                    </Button>
                </Grid>

            </Grid>
        </Paper>
    );
};
